module.exports = __webpack_public_path__ + "img/authentication.0f52f012.png";